<template>
  <div class="range">
    <itemSearch v-bind="$attrs">
      <span class="item" v-if="!noLabel">{{label}}</span>
      <el-input size="medium" class="item" @change="bindVal" v-model="start"></el-input>
      <span class="item line"></span>
      <el-input size="medium" class="item" @change="bindVal" v-model="end"></el-input>
      <el-button size="small" type="warning" class="item" @click="confirm" v-if="!noSearch">确定</el-button>
      <div slot="toolTips">{{toolContent}}</div>
    </itemSearch>
  </div>
</template>
<script>
import itemSearch from "@/components/iglobalwin/formComponents/SkySuffix.vue";
import formStore from '@/mixins/formStore.js'
export default {
  props: {
    value: Array,
    label: String,
    noSearch: Boolean,
    noLabel: Boolean,
    toolContent: String
  },
  components: { itemSearch },
  mixins: [formStore],
  data() {
    return {
      start: this.value[0] || undefined,
      end: this.value[1] || undefined
    };
  },
  computed: {},
  watch: {
    value: function(val) {
      this.start = val[0] || undefined;
      this.end = val[1] || undefined;
    }
  },
  mounted() {},
  methods: {
    bindVal() {
      this.noSearch && this.confirm();
    },
    setVal () {
      this.$emit('input', [this.start, this.end])
    },
    getVal () {
      this.start = this.value[0] || undefined;
      this.end = this.value[1] || undefined;
    },
    confirm() {
      !this.delay && this.setVal()
    }
  }
};
</script>
<style lang="scss" scoped>
.range {
  display: flex;
  align-items: center;
  .el-button {
    margin-left: 5px;
  }
  .el-input {
    width: 90px;
  }
  .item {
    margin-right: 5px;
  }
  .line {
    width: 9px;
    background-color: #4a4a4a;
    height: 1px;
  }
}
</style>
